import React from 'react';
import DetailedHeader from '../../../../components/ProjectDetailedPageComponents/DetailedHeader';
import ImageSlider from '../../../../components/Misc/ImageSlider';
import projectImage1 from '../../../../assets/images/work/certifire/Certifire_Slider.jpg';
import projectImage2 from '../../../../assets/images/work/certifire/Certifire_Slider_2.jpg';
import projectImage3 from '../../../../assets/images/work/certifire/Certifire_Slider_3.jpg';
import projectImage4 from '../../../../assets/images/work/certifire/Certifire_Slider_4.jpg';
import projectImage5 from '../../../../assets/images/work/certifire/Certifire_Slider_5.jpg';
import projectImage6 from '../../../../assets/images/work/certifire/Certifire_Slider_6.jpg';
import projectImage7 from '../../../../assets/images/work/certifire/Certifire_Slider_7.jpg';


import Data_CertiFire from './Data_CertiFire';

function Work_CertiFire() {
    return (
        <>
            <DetailedHeader
                heading="Redefining Fire Alarm Technician Training"
                client="ECAO, Certi-Fire"
                service="Virtual Reality"
                date="2023-Present"
            />
            <ImageSlider
                noArt="true"
                swiperNav="true"
                youtubeUrl="https://www.youtube.com/watch?v=biZxcipVRFI"
                images={[
                    {
                        image: projectImage1,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage2,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage3,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage4,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage5,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage6,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage7,
                        alt: 'Project Image',
                    },
                ]}
            />

            {Data_CertiFire.content}
        </>
    );
}

export default Work_CertiFire;
